// extracted by mini-css-extract-plugin
export default {"container":"MyInvoicesComponent_container__jfSex","items_container":"MyInvoicesComponent_items_container__ybF7W"};